import { InjectionToken } from '@angular/core';

/** Disable Bitwarden autofill within a configuration editor's component tree. */
export const IGNORE_BITWARDEN_AUTOFILL = new InjectionToken<boolean>(
  'IGNORE_BITWARDEN_AUTOFILL',
  { providedIn: 'root', factory: () => false }
);
